//#region Function Imports
import React, { useState, useEffect } from "react";
import { FlatList, StyleSheet, SafeAreaView, View, Platform, useWindowDimensions, Switch, ActivityIndicator } from "react-native";
import CustomLabel from "../../../components/CustomLabel/CustomLabel";
import CustomButton from "../../../components/CustomButton/CustomButton";
import { Card } from "react-native-paper";
import { useTranslation } from "react-i18next";
import { useTheme } from '@react-navigation/native';
import { createCommonStyles } from "../../../styles/commonStyles";
import * as Progress from "react-native-progress";

//#endregion

const MyAssessments = (props) => {
  //#region Function Consts
  const { t } = useTranslation();
  const { width, height } = useWindowDimensions();
  const isHalfScreen = Platform.OS === "web" && width <= 900;
  const progressBarWidth = Math.max(Math.min(width * 0.1, 100), 60);
  const { colors } = useTheme();
  // const { isLoading } = useAssessment();
  const styles = makeStyles(colors, height, width);
  const common = createCommonStyles(colors);
  const [showPending, setShowPending] = useState(false);
  //#endregion

  //#region Useeffect
  useEffect(() => {
    // * No need to do anything here
  }, [width, height]);

  useEffect(() => {
    props.loadUserAssessments()
  }, [])
  //#endregion

  //#region Render Functions
  const AssessmentListView = ({ item, isHalfScreen }) => {
    // * Hide Completed
    if (item.active == true && item.submitted == true && showPending) {
      return (<></>)
    }
    // * Hide Closed
    if (item.active == false && item.submitted == false && showPending) {
      return (<></>)
    }
    return (
      <Card style={[common.cardstyle, styles.cardstyle]
      }>
        <Card.Content>
          <View style={styles.showhide}>
            <SafeAreaView style={styles.row}>
              <View style={styles.columLabels}>
                <CustomLabel value={t(item.assessment)} type="SUBTITLE" />
              </View>
              <View style={styles.verticalLine} />
              {!isHalfScreen && (Platform.OS === 'web') && (
                <>
                  <View style={styles.columLabels}>
                    <CustomLabel value={t(item.type)} type="SUBTITLE" />
                  </View>
                  <View style={styles.verticalLine} />
                  {item.submitted === false ? (
                    <View style={styles.button}>
                      <CustomButton
                        iconName="ellipse-outline"
                        show="icon_HIDE"
                        type="SUBTITLE"
                        textTop="2"
                        sz={Platform.OS === 'web' ? 25 : 15}
                        disabled
                      />
                    </View>
                  ) : (
                    <View style={styles.button}>
                      <CustomButton
                        iconName="checkmark-circle-outline"
                        show="icon_HIDE"
                        type="SUBTITLE"
                        textTop="2"
                        sz={Platform.OS === 'web' ? 25 : 15}
                        disabled
                      />
                    </View>
                  )}
                  <View style={styles.verticalLine} />
                  <View style={styles.columLabels}>
                    <CustomLabel value={t(item.cType)} type="SUBTITLE" />
                  </View>
                  <View style={styles.verticalLine} />
                </>)}
              <SafeAreaView style={styles.columLabelsProgress}>
                <CustomLabel
                  value={t(item.progress + "/" + item.total)}
                  type="SUBTITLE"
                />
                <Progress.Bar
                  progress={item.progress / item.total}
                  width={progressBarWidth}
                  color="black"
                />
              </SafeAreaView>
              <View style={styles.verticalLine} />
              {item.active === true && item.submitted === false ? (
                <View style={styles.button}>
                  <CustomButton
                    type="PENDING"
                    text={t("common:assessmentpending")}
                    onPress={() => {
                      props.setShowMyAssessments(0);
                      props.setShowResponseScreen(1);
                      props.setAssessmentToLoad(item);
                      props.setResponse(1);
                    }}
                    show="HIDE"
                  />
                </View>
              ) : item.active == true && item.submitted == true ? (
                <View style={styles.button}>
                  <CustomButton
                    type="COMPLETE"
                    text={t("common:assessmentcomplete")}
                    onPress={() => {
                      props.setShowMyAssessments(0);
                      props.setShowResponseScreen(1);
                      props.setAssessmentToLoad(item);
                      props.setResponse(0);
                      //props.setResponseAssessmentId(item.id)
                    }}
                    show="HIDE"
                  />
                </View>
              ) : (
                <View style={styles.button}>
                  <CustomButton
                    type="CLOSED"
                    text={t("common:assessmentclosed")}
                    onPress={() => { }}
                    disabled={true}
                    show="HIDE"
                  />
                </View>
              )}
            </SafeAreaView>
          </View>
        </Card.Content>
      </Card>
    );
  };
  /* //TODO              {item.completed_on !== null ? 
                            <View style={styles.button} >
                                <CustomButton
                                    iconName = 'close-circle-outline'
                                    onPress={() => {
                                        console.log("check")
                                    }}
                                    show='HOME_BELL'
                                    type='HOME_BELL'
                                    textTop='2'
                                    sz={20} 
                                    value ="Submited" />
                            </View>
                            :
                            <View style={styles.button} >
                                <CustomButton
                                iconName = 'checkmark-circle-outline'
                                onPress={() => {
                                    console.log("check")
                                }}
                                show='HOME_BELL'
                                type='HOME_BELL'
                                textTop='2'
                                sz={20} 
                                value ="Submited" />
                            </View>}
                            {item.completed_on !== null ?
                                <View
                                    style={styles.button}>
                                    <CustomButton
                                        type="PENDING"
                                        text={t('common:assessmentpending')}
                                        onPress={() => {
                                            props.setShowMyAssessments(1)
                                            props.setShowResponseScreen(0)
                                            props.setResponseAssessmentId(item.id)
                                        }}
                                        show="HIDE"
                                    />
                            </View>:
                                <View
                                    style={styles.button}>
                                    <CustomButton
                                        type="COMPLETE"
                                        text={t('common:assessmentcomplete')}
                                        onPress={() => {
                                            props.setShowMyAssessments(0)
                                            props.setShowResponseScreen(1)
                                            props.setResponseAssessmentId(item.id)
                                        }}
                                        show="HIDE"
                                    />
                                </View>}    */

  const renderAssessments = ({ item, isHalfScreen }) => {
    return (
      <AssessmentListView item={item} isHalfScreen={isHalfScreen} />
    );
  };
  //#endregion

  //#region Listeners 
  const togglePending = () => {
    setShowPending(!showPending)
  }
  //#endregion

  return (
    <SafeAreaView style={styles.mainView}>
      <View style={styles.listWrapper}>
        <FlatList
          data={props.data}
          renderItem={({ item }) => renderAssessments({ item, isHalfScreen })}
          onRefresh={() => props.loadUserAssessments()}
          scrollEnabled={true}
          contentContainerStyle={{ flexGrow: 1 }}
          refreshing={props.isLoading}
          ListEmptyComponent={
            props.isLoading &&
            <SafeAreaView
              style={styles.mainView}>
              <ActivityIndicator animating={true} size='large' color="#86BC25" />
            </SafeAreaView>
          }
          ListHeaderComponent={
            <SafeAreaView>
              {/* // * Flatlist Filtering */}
              <SafeAreaView
                style={styles.rowMargin}>
                <SafeAreaView
                  style={styles.rowNoflex}>
                  <CustomLabel
                    value={t('common:togglePending')}
                    type='TIMESHEET_APPROVE' />
                  <View style={styles.split} />
                  <Switch
                    value={showPending ? true : false}
                    onValueChange={() => togglePending()} />
                </SafeAreaView>
              </SafeAreaView>
              {/* // * Flatlist Titles */}
              <SafeAreaView style={common.listTitle}>
                <SafeAreaView style={styles.rowHeader}>
                  <CustomLabel value={t("common:assessmentname")} type="SUBTITLE" />
                  <View style={styles.verticalLine} />
                  {!isHalfScreen && (Platform.OS === 'web') && (
                    <>
                      <CustomLabel value={t("common:assessmenttype")} type="SUBTITLE" />
                      <View style={styles.verticalLine} />
                      <CustomLabel
                        value={t("common:assessmentsubmited")}
                        type="SUBTITLE"
                      />
                      <View style={styles.verticalLine} />
                      <CustomLabel
                        value={t("common:assessmentstage")}
                        type="SUBTITLE"
                      />
                      <View style={styles.verticalLine} />
                    </>)}
                  <CustomLabel value={t("common:progress")} type="SUBTITLEPROGRESS" />
                  <View style={styles.verticalLine} />
                  <CustomLabel
                    value={t("common:status")}
                    type="SUBTITLE"
                  />
                </SafeAreaView>
                <SafeAreaView style={common.divider} />
              </SafeAreaView>

            </SafeAreaView>
          }
          initialNumToRender={4}
        />
      </View>
    </SafeAreaView>
  );
};

const makeStyles = (colors, height, width) =>
  StyleSheet.create({
    mainView: {
      flex: 1,
      height: Platform.OS === "web" ? (height * 60) / 100 : "95%",
      justifyContent: "center",
    },
    listWrapper: {
      felx: 1,
      padding: Platform.OS === 'web' ? 10 : 1,
      marginBottom: 10,
      height: '100%'
    },
    cardstyle: {
      marginBottom: 0,
      marginVertical: 20,
    },
    verticalLine: {
      backgroundColor: colors.buttons_primary,
      height: '100%',
      width: 1,
    },
    row: {
      flex: 1,
      flexDirection: "row",
    },
    rowMargin: {
      flex: 1,
      flexDirection: "row",
      justifyContent: 'flex-end',
      marginRight: 15,
      marginBottom: 15,
    },
    rowHeader: {
      flexDirection: "row",
      marginHorizontal: Platform.OS === 'web' ? '2%' : 0,
    },
    rowNoflex: {
      flexDirection: "row",
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    split: {
      margin: 5,
    },
    button: {
      flex: 1,
      marginHorizontal: Platform.OS === 'web' ? 0 : 1,
      justifyContent: "center",
      alignSelf: "center",
      alignItems: "center",
    },
    columLabels: {
      flex: 1,
      marginRight: Platform.OS === 'web' ? 0 : 3,
      justifyContent: "center",
      alignSelf: "center",
      alignItems: "center",
    },
    columLabelsProgress: {
      flex: 1,
      justifyContent: "center",
      alignSelf: "center",
      alignItems: "center",
      margin: 15,
    },
    inputContainer: {
      margin: "1%",
      flex: 1,
      width: "100%",
      justifyContent: "flex-end",
    },
  });

export default MyAssessments;
